import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import {
  Modal,
  Box,
  Typography,
  Button,
  Card,
  CardHeader,
  CardContent,
  CardActions,
} from '@mui/material';
import { useNavigate } from 'react-router';

import { ROUTE_PATH, STRINGS } from '../../../constants';
import { CitysprintWizardActions } from '../redux';

export const CitysprintSessionExpiredModal = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleClose = useCallback(() => {
    dispatch(CitysprintWizardActions.clear());
    navigate(ROUTE_PATH.SEND_A_CITYSPRINT_PARCEL);
  }, [dispatch, navigate]);

  return (
    <Modal
      open
      onClose={handleClose}
      aria-labelledby='session-expired-title'
      aria-describedby='session-expired-description'
    >
      <Card
        variant='elevation'
        sx={{
          position: 'relative',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          maxWidth: '500px',
          width: '100%',
        }}
        role='dialog'
      >
        <CardHeader
          title={
            <Box display='flex' id='session-expired-title'>
              <Typography variant='h6' gutterBottom>
                {STRINGS.YOUR_SESSION_HAS_EXPIRED}
              </Typography>
            </Box>
          }
        />
        <CardContent id='session-expired-description'>
          <Typography variant='body1' gutterBottom>
            {STRINGS.YOUR_SESSION_HAS_EXPIRED_REFRESH_TO_CONTINUE}
          </Typography>
        </CardContent>
        <CardActions sx={{ display: 'flex', justifyContent: 'flex-end', p: 2 }}>
          <Box>
            <Button variant='outlined' color='primary' onClick={handleClose}>
              {STRINGS.CLOSE}
            </Button>
          </Box>
        </CardActions>
      </Card>
    </Modal>
  );
};
